import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("admin_token", data.access_token);
      navigate("/admin/panel");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-beige-soft flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm bg-white border border-stone-200 p-10"
      >
        <span className="font-serif text-3xl text-stone-900 tracking-tight">İnegöl <span className="text-wood-light">Mobilya</span></span>
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-500 mt-2 mb-8">Yönetici Girişi</p>
        <form onSubmit={submit} className="flex flex-col gap-5" data-testid="admin-login-form">
          <div className="flex flex-col gap-2">
            <Label htmlFor="username">Kullanıcı Adı</Label>
            <Input id="username" value={username} onChange={(e) => setUsername(e.target.value)} required data-testid="admin-username-input" />
          </div>
          <div className="flex flex-col gap-2">
            <Label htmlFor="password">Şifre</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="mt-2 bg-stone-900 hover:bg-wood text-stone-50 rounded-none" data-testid="admin-login-submit">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
        </form>
        <a href="/" className="block mt-6 text-xs text-stone-500 link-underline" data-testid="admin-back-to-site">← Siteye dön</a>
      </motion.div>
    </div>
  );
}
